import { Client } from "@microsoft/microsoft-graph-client";

 
import 'cross-fetch/polyfill'; // ✅ works better


 export const createTeamsMeetingEvent = async ({ subject, startDateTime, endDateTime, attendees, instance }) => {
  
  const account = instance.getAllAccounts()[0];
  
  const tokenResponse = await instance.acquireTokenSilent({
    scopes: ["Calendars.ReadWrite", "User.Read"],
    account,
  });

  const client = Client.init({
    authProvider: (done) => done(null, tokenResponse.accessToken),
  });

  const meeting = await client.api("/me/events").post({
    subject,
    start: { dateTime: startDateTime, timeZone: "UTC" },
    end: { dateTime: endDateTime, timeZone: "UTC" },
    isOnlineMeeting: true,
    onlineMeetingProvider: "teamsForBusiness",
    attendees: attendees.map((email) => ({
      emailAddress: { address: email, name: email },
      type: "required",
    })),
  });

  return { meetingUrl: meeting.onlineMeeting?.joinUrl || "", eventId: meeting.id };
};

export const cancelTeamsMeetingEvent = async ({ eventId, instance }) => {
  const account = instance.getAllAccounts()[0];

  const tokenResponse = await instance.acquireTokenSilent({
    scopes: ["Calendars.ReadWrite", "User.Read"],
    account,
  });

  const client = Client.init({
    authProvider: (done) => done(null, tokenResponse.accessToken),
  });

  try {
    await client.api(`/me/events/${eventId}`).delete();
    return { success: true, message: "Meeting cancelled successfully." };
  } catch (error) {
    return { success: false, message: error.message || "Failed to cancel meeting." };
  }
};
